
// Cape Hatteras page
$(document).on("click", "#waves-d-trigger", function() {
	$(".card-waves").addClass("real-card-active");
  	$(".card-waves").removeClass("real-card-inactive");
    $(".card-wind").addClass("real-card-inactive");
  	$(".card-wind").removeClass("real-card-active");
  	$(".card-beaches").addClass("real-card-inactive");
  	$(".card-beaches").removeClass("real-card-active");
     $('#waves-d').collapse('toggle');
  $('#waves-m').collapse('toggle');
	$('#wind-d').collapse('hide');
	$('#beaches-d').collapse('hide');
});

$(document).on("click", ".card-waves img", function() {
	$(".card-waves").addClass("real-card-active");
  	$(".card-waves").removeClass("real-card-inactive");
    $(".card-wind").addClass("real-card-inactive");
  	$(".card-wind").removeClass("real-card-active");
  	$(".card-beaches").addClass("real-card-inactive");
  	$(".card-beaches").removeClass("real-card-active");
    $('#waves-d').collapse('toggle');
  $('#waves-m').collapse('toggle');
	$('#wind-d').collapse('hide');
	$('#beaches-d').collapse('hide');
});
								
$(document).on("click", "#wind-d-trigger", function() {
	$(".card-wind").addClass("real-card-active");
  	$(".card-wind").removeClass("real-card-inactive");
    $(".card-waves").addClass("real-card-inactive");
    $(".card-waves").removeClass("real-card-active");
  	$(".card-beaches").addClass("real-card-inactive");
    $(".card-beaches").removeClass("real-card-active");
   $('#wind-d').collapse('toggle');
  $('#wind-m').collapse('toggle');
	$('#waves-d').collapse('hide');
	$('#beaches-d').collapse('hide');
});	

$(document).on("click", ".card-wind img", function() {
	$(".card-wind").addClass("real-card-active");
  	$(".card-wind").removeClass("real-card-inactive");
    $(".card-waves").addClass("real-card-inactive");
    $(".card-waves").removeClass("real-card-active");
  	$(".card-beaches").addClass("real-card-inactive");
    $(".card-beaches").removeClass("real-card-active");
  $('#wind-d').collapse('toggle');
  $('#wind-m').collapse('toggle');
	$('#waves-d').collapse('hide');
	$('#beaches-d').collapse('hide');
});	
$(document).on("click", "#beaches-d-trigger", function() {
	$(".card-beaches").addClass("real-card-active");
  	$(".card-beaches").removeClass("real-card-inactive");
    $(".card-waves").addClass("real-card-inactive");
    $(".card-waves").removeClass("real-card-active");
  	$(".card-wind").addClass("real-card-inactive");
    $(".card-wind").removeClass("real-card-active");
   $('#beaches-d').collapse('toggle');
  $('#beaches-m').collapse('toggle');
	$('#waves-d').collapse('hide');
	$('#wind-d').collapse('hide');
});							

$(document).on("click", ".card-beaches img", function() {
	$(".card-beaches").addClass("real-card-active");
  	$(".card-beaches").removeClass("real-card-inactive");
    $(".card-waves").addClass("real-card-inactive");
    $(".card-waves").removeClass("real-card-active");
  	$(".card-wind").addClass("real-card-inactive");
    $(".card-wind").removeClass("real-card-active");
  $('#beaches-d').collapse('toggle');
  $('#beaches-m').collapse('toggle');
	$('#waves-d').collapse('hide');
	$('#wind-d').collapse('hide');
});	